module.exports = __webpack_public_path__ + "img/Gold Nova II.6a4d6b53.png";